
function App() {
  return (
    <h1>Hello React (created with Create React App)!</h1>
  );
}

export default App;
